import './NotFound.styles.scss';

import React from 'react';
// import { Link as RouterLink } from 'react-router-dom';
import DocTitleScrollTop from '../../utils/DocTitleScrollTop';

const NotFoundPage = () => {
  DocTitleScrollTop('Not Found');

  return (
    <div className="notFoundPage">
      <div className="mfa-container">
        <div className="notFoundContent">
          <div >
            Whoops, we cannot find that page.
          </div>
          <div >
            You can always visit{' '}
            {/* <Link to="/" color="primary" component={RouterLink}>
              homepage
            </Link>{' '} */}
            to get a fresh start.
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
